<template>
  <div class="tool h-100">
    <app-title title="Tool"/>

    <div class="row">
      <div class="col-md-3 sidebar sidebar-left p-md-3">
        <img class="header-logo" src="/images/logo.svg">
      </div>
      <div class="col-md-7 content-middle dashboard-row p-md-3 mt-md-3">
        <span @click="gotoDashboard" class="link">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-left"/> Dashboard
        </span>
      </div>
      <div class="col-md-3 sidebar sidebar-right sidebar-account p-md-3">
        <app-account v-if="isAuthenticated"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 d-none d-sm-block sidebar sidebar-left">

      </div>

      <div class="col-md-7 content-middle main p-md-3">
        <app-reference ref="appReference"/>
      </div>

      <app-showalert ref="appShowAlert"/>

      <div class="col-md-3 d-none d-sm-block sidebar sidebar-right">

      </div>
    </div>

    <div class="row lastrow">
      <div class="col-md-3 sidebar sidebar-left p-md-3">
        <app-materials/>
      </div>
      <div class="col-md-7 content-middle p-md-3 d-flex">
        <app-brutoplates v-if="materialBruto"/>
        <app-panels v-else-if="panelType === 'pom'"/>
        <app-furniturepanels v-else-if="panelType === 'furniture'"/>
      </div>
      <app-overview/>
    </div>

    <div v-if="disablePanelInput" class="disablepanelinput modal modal-backdrop show fade offset-md-3 col-md-10"></div>
    <div v-if="calculatingStatus === true" class="disablepanelinput modal cursor-wait col-md-13"></div>

    <b-modal ref="save-offer-modal" id="save-offer-modal" footer-class="modal-footer modal-save-offer" centered>
      <template slot="modal-header">
        <h4 class="modal-title">Let op!</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          U gaat terug naar het dashboard.<br/>
          Wilt u eerst uw offerte opslaan?
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="hideModal"
          type="button"
          class="btn btn-round link">Annuleren
        </button>
        <button
          @click="deleteSaveOffer"
          type="button"
          class="btn btn-round link">Invoer verwijderen
        </button>
        <button
          @click="confirmSaveOffer"
          type="button"
          class="btn btn-oldevuuren btn-round">Offerte opslaan
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { FETCH_FILTERS, FETCH_PRODUCTS, FETCH_SIDES, MUTATE_IS_LOADING_MATERIAL, SAVE_ORDER, RESET_CART } from '../store/types'
  // Materials (left side)
  import Materials from '@/components/Tool/Materials/Materials.vue'
  // Panels (middle)
  import Panels from '@/components/Tool/Panels/Panels.vue'
  import FurniturePanels from '@/components/Tool/Panels/FurniturePanels.vue'
  import BrutoPlates from '@/components/Tool/Panels/BrutoPlates.vue'
  import Reference from '@/components/Tool/Panels/Reference.vue'
  import ShowAlert from '@/components/Tool/Panels/ShowAlert.vue'
  // Overview (right side)
  import Overview from '@/components/Tool/Overview/Overview.vue'
  import Account from '@/components/Account/Account.vue'

  export default {
    name: 'tool',
    data() {
      return {}
    },
    components: {
      'app-materials': Materials,
      'app-panels': Panels,
      'app-furniturepanels': FurniturePanels,
      'app-brutoplates': BrutoPlates,
      'app-overview': Overview,
      'app-reference': Reference,
      'app-showalert': ShowAlert,
      'app-account': Account
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.isAuthenticated
      },
      reference() {
        return !this.$store.getters.cartReference ? false : this.$store.getters.cartReference
      },
      disablePanelInput() {
        return this.$store.getters.disablePanelInput
      },
      calculatingStatus() {
        return this.$store.getters.calculatingStatus
      },
      savingOrder() {
        return this.$store.getters.savingOrder
      },
      cart() {
        return !this.$store.getters.cart ? null : this.$store.getters.cart
      },
      panelType() {
        return this.$store.getters.filterDeliveryProgram === 'Meubelpanelen' ? 'furniture' : 'pom'
      },
      materialBruto() {
        return this.$store.getters.materialBruto
      }
    },
    methods: {
      gotoDashboard() {
        if (this.isAuthenticated) {
          if (this.savingOrder === false) {
            // Offer already saved... Redirect the user
            this.$router.push({ path: 'dashboard' })
          } else {
            this.$refs['save-offer-modal'].show()
          }
        } else {
          this.login()
        }
      },
      deleteSaveOffer() {
        // Emtpy cart
        // this.$store.dispatch(SAVE_ORDER, null)
        this.$store.dispatch(RESET_CART)
        this.hideModal()
        // Redirect the user
        this.$router.push({ path: 'dashboard' })
      },
      confirmSaveOffer() {
        // Save offer
        this.$store.dispatch(SAVE_ORDER, this.cart)
        this.hideModal()
        // Empty cart & return to the dashboard
        this.$store.dispatch(RESET_CART)
        this.$router.push({ path: 'dashboard' })
      },
      hideModal() {
        this.$refs['save-offer-modal'].hide()
      }
    },
    updated() {
      // After creating/adding/deleting/switching materials
      this.$store.commit(MUTATE_IS_LOADING_MATERIAL, false)
    },
    mounted() {
      // Load panel types & products
      this.$store.dispatch(FETCH_FILTERS)
      this.$store.dispatch(FETCH_PRODUCTS)
      this.$store.dispatch(FETCH_SIDES)

      // TODO, remove debug function
      // this.$store.dispatch(TOOL_LOAD_CART_FROM_LOCAL_STORAGE)

      if (!this.reference) {
        this.$refs.appReference.showModal()
      }
      // ShowAlert model disabled, leave functionality for the next time...
      // this.$refs.appShowAlert.showModal()
    }
  }
</script>

<style lang="scss" scoped>
  .tool-dashboard-link {
    font-weight: bold;
  }
</style>

<style>
  /* Allow scrolling for this one modal (which is invisible) */
  /* @TODO This should only be set temporary, the moment the modal closes, this should be set back to 'hidden' again */
  .modal-open {
    overflow: auto !important;
  }

  .cursor-wait {
    cursor: wait;
  }
</style>
